<template>
  <div>
    <vue-table :table-data="tableData" ref="vueTable" size="mini">
      <template slot="operateBar">
        <el-button v-if="checkApi('addLicensePrice')" size="small" type="primary" @click="add">添加</el-button>
      </template>
      <template #price="{row}">
        <span>{{convertYuan(row.price)}}</span>
      </template>
      <template #discount="{row}">
        <span v-if="row.discount_type === 0">-</span>
        <span v-else-if="row.discount_type === 1">{{convertYuan(row.discount_value)}}</span>
        <span v-else-if="row.discount_type === 2">{{convertYuan(row.price - Math.round(row.price * row.discount_value / 100))}}（{{(row.discount_value / 10).toFixed(1)}}折）</span>
      </template>
      <template #discount_price="{row}">
        <span v-if="row.discount_type === 0">{{convertYuan(row.price)}}</span>
        <span v-else-if="row.discount_type === 1">{{convertYuan(row.price - row.discount_value)}}</span>
        <span v-else-if="row.discount_type === 2">{{convertYuan(Math.round(row.price * row.discount_value / 100))}}</span>
      </template>
      <template v-if="hasApi(['modLicensePrice','delLicensePrice'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="100">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('modLicensePrice')" type="text" @click="revise(row)">修改</el-button>
            <el-button v-if="checkApi('delLicensePrice')" type="text" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <table-operate v-if="tableOperate.visible" :dialog-data="tableOperate" @getData="getData"/>
  </div>
</template>

<script>
import {licenseType, licensePriceUnit, licenseIsRecommend, commonStatusBoole} from "@utils/formatList";
import TableOperate from "./dialog/TableOperate.vue"
export default {
  name: "index",
  components: {TableOperate},
  data() {
    return {
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "授权类型", property: "type", format: licenseType, width: 80},
          {label: "单位", property: "unit", format: licensePriceUnit},
          {label: "价格(元)", property: "price"},
          {label: "优惠价(元)", property: "discount"},
          {label: "优惠后(元)", property: "discount_price", width: 120},
          {label: "是否推荐", property: "is_recommend", format: licenseIsRecommend},
          {label: "状态", property: "status", format: commonStatusBoole},
          {label: "备注", property: "remark"},
        ],
        api: "getLicensePriceList",
      },
      tableOperate: {visible: false, width: 450, title: "", row: null},
    }
  },
  methods: {
    add() {
      this.tableOperate.visible = true;
      this.tableOperate.title = "添加";
      this.tableOperate.row = null;
    },
    revise(row) {
      this.tableOperate.visible = true;
      this.tableOperate.title = "修改";
      this.tableOperate.row = row;
    },
    remove(row) {
      this.openConfirm("确定要删除该授权价格", async () => {
        let nv = {license_price_id: row.id};
        let res = await this.$Http.delLicensePrice(nv);
        if (res) {
          this.msgSuccess("操作成功");
          this.getData();
        }
      });
    },
    getData() {
      this.$refs["vueTable"].refresh();
    }
  }
}
</script>

<style scoped>

</style>